<template>
  <v-dialog persistent v-model="show" width="600" content-class="popup-wrap-1">
    <div class="pa-8">
      <v-form ref="form">
        <h3 class="title-type-4 mb-2">매체 지면 관리</h3>
        <p class="form-coment-1 mt-3 mb-2">
          <v-icon>mdi-alert-circle-outline</v-icon>
          지면 정보 입력 후 저장버튼을 꼭 클릭해주세요.
        </p>

        <div class="section-gap-1">
          <h3 class="title-type-3">
            지면명
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <v-text-field
            placeholder="20자 이내 입력해주세요."
            class="input-custom-2"
            height="40px"
            v-model="inventory.name"
            readonly
            solo
          />
          <p class="form-coment-1 mt-n2">
            <v-icon>mdi-alert-circle-outline</v-icon>
            등록후 매체명은 변경이 불가합니다.
          </p>
        </div>

        <div class="section-gap-1">
          <h3 class="title-type-3">
            동시 노출 제한
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <v-select
            :items="overlapCntItems"
            v-model="inventory.overlap_cnt"
            :rules="[rules.required]"
            item-color="#000"
            class="input-custom-2"
            height="40px"
            solo
          />
        </div>

        <div class="section-gap-1">
          <h3 class="title-type-3">
            애드비전 사용 여부
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <p class="text-type-1">애드비전 사용 여부를 설정하실 수 있습니다.</p>
          <div class="mt-2">
            <v-switch
              inset
              color="#fecd00"
              v-model="useAdvision"
              :label="useAdvision ? '사용' : '미사용'"
              class="switch-type-1"
            ></v-switch>
          </div>
        </div>

        <div class="section-gap-1">
          <h3 class="title-type-3">
            지면 옵션 선택
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <p class="text-type-1">
            등록할 매체의 지면들이 사용할 지면 특성만 선택하면 등록을 간편하게
            하실 수 있습니다.
          </p>
          <p class="form-coment-1 mt-2">
            <v-icon>mdi-alert-circle-outline</v-icon>
            지면 옵션 추가는 소스 개발 후 적용 가능합니다.
          </p>
          <div class="mt-2">
            <v-btn
              depressed
              max-height="32px"
              :color="isAllChecked ? '#eee' : '#fecd06'"
              class="button-type-1"
              @click.prevent="checkAllOrNon"
            >
              {{ isAllChecked ? '선택 해제' : '전체 선택' }}
            </v-btn>
          </div>
          <ul class="chx-list-type-1 four">
            <li v-for="(option, index) in media.options" :key="index">
              <v-checkbox
                v-model="optionChx"
                :value="option.id"
                :label="option.name"
                @click="
                  checkedOptionKeys[option.key] = !checkedOptionKeys[option.key]
                "
                color="#fecd00"
                off-icon="mdi-checkbox-blank"
                class="checkbox-type-1"
                hide-details
              />
            </li>
          </ul>
        </div>

        <div class="section-gap-1">
          <h3 class="title-type-3 mb-2">
            지면 옵션 비교 조건
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <p class="form-coment-1">
            <v-icon>mdi-alert-circle-outline</v-icon>
            옵션의 비교 조건을 등록합니다.
          </p>
          <HoleOption
            v-if="checkedOptionKeys['hole']"
            ref="holeCondition"
            :propCondition="propConditions['hole']"
          />
          <ImageOption
            v-if="checkedOptionKeys['image']"
            ref="imageCondition"
            :propCondition="propConditions['image']"
          />
          <VideoOption
            v-if="checkedOptionKeys['video']"
            ref="videoCondition"
            :propCondition="propConditions['video']"
          />
        </div>

        <div class="section-gap-1">
          <h3 class="title-type-3 mb-2">
            지면 샘플 이미지
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <p class="form-coment-1">
            <v-icon>mdi-alert-circle-outline</v-icon>
            지면의 실제 노출 광고 상품 샘플 이미지를 등록합니다.
          </p>
          <div class="file-upload-box-2">
            <div class="file-thumb">
              <img v-if="file.thumb" :src="file.thumb" alt="" />
              <v-icon v-else>mdi-image-outline</v-icon>
            </div>
            <div class="file-text">
              <div class="file-wrap">
                <v-btn
                  large
                  depressed
                  max-height="32px"
                  color="#fecd06"
                  class="button-type-1"
                  type="file"
                >
                  파일 업로드
                </v-btn>
                <input type="file" @change="onFileChange" accept="image/png" />
              </div>
              <p class="form-coment-1 my-2">
                <v-icon>mdi-alert-circle-outline</v-icon>
                PNG 파일만 사용 가능 용량 제한
              </p>
              <p class="file-name mb-0" v-if="file.name">
                {{ file.name }}
              </p>
            </div>
            <div class="file-size">
              <p>Width: 200px ~ 768px</p>
            </div>
          </div>
        </div>

        <div class="section-gap-1">
          <h3 class="title-type-3">
            지면 설명
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <v-textarea
            solo
            placeholder="200자 이내 입력해주세요."
            color="#eee"
            height="74px"
            class="input-custom-2"
            v-model="inventory.note"
            :rules="[rules.required, rules.maxLength(200)]"
          ></v-textarea>
        </div>

        <div class="d-flex justify-end mt-2">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fff"
            class="button-type-1"
            @click="cancel"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1 ml-2"
            @click="registerInventory"
          >
            저장
          </v-btn>
        </div>
      </v-form>
    </div>

    <SystemAlert :persistent="true" v-model="showSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </v-dialog>
</template>

<script>
import bus from '@/utils/bus';
import { updateInventory } from '@/api/inventory';
import { uploadWithNewPermission } from '@/api/etc';

import SystemAlert from '~@/modal/SystemAlert.vue';
import HoleOption from '~@/option/HoleOption.vue';
import ImageOption from '~@/option/ImageOption.vue';
import VideoOption from '~@/option/VideoOption.vue';

export default {
  props: {
    value: Boolean,
    inventory: Object,
    media: Object,
  },
  components: { SystemAlert, HoleOption, ImageOption, VideoOption },
  data: () => ({
    file: {
      img: null,
      name: null,
      thumb: null,
    },
    overlapCntItems: new Array(10).fill(0).map((v, i) => i + 1),
    optionChx: [],
    rules: {
      required: v => !!v || '필수 항목입니다.',
      maxLength: length => {
        return v =>
          (!!v && v.length <= length) || `최대 ${length}자까지 가능합니다.`;
      },
    },
    resultType: '',
    logResult: '',
    showSystemAlert: false,
    checkedOptionKeys: {},
    propConditions: {},
    useAdvision: false,
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isAllChecked() {
      return this.media.options.length <= this.optionChx.length;
    },
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.file.name = file.name;
      this.file.thumb = URL.createObjectURL(file);
      this.file.img = file;
    },
    async registerInventory() {
      const validate = this.$refs.form.validate();
      if (!validate) return;

      bus.$emit('start:spinner');
      try {
        // 예시 이미지를 골랐으면 저장 직전에 업로드하고, 실패하면 저장하지 않는다
        let sampleImage = null;
        if (this.file.img) {
          try {
            sampleImage = await uploadWithNewPermission('png', this.file.img);
          } catch (error) {
            console.log(error.response);
            bus.$emit('end:spinner');
            this.showSystemAlert = true;
            this.logResult =
              '이미지 업로드에 실패하였습니다. 다시 시도해주세요.';
            return;
          }
        }

        const updateData = {
          name: this.inventory.name,
          overlap_cnt: this.inventory.overlap_cnt,
          note: this.inventory.note,
          use_advision: this.useAdvision ? 'Y' : 'N',
          options: this.optionChx.map(id => {
            const option = this.media.options.find(o => o.id === id);
            const $refCondition = this.$refs[`${option.key}Condition`];
            return {
              id: option.id,
              condition: $refCondition ? $refCondition.getValues() : null,
            };
          }),
        };
        if (sampleImage) updateData.sample_image = sampleImage;

        const { data } = await updateInventory(this.inventory.id, updateData);

        if (data.result === 'success') {
          bus.$emit('end:spinner');
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.logResult = '매체 지면이 수정되었습니다.';
          this.show = false;
          this.clearForm();
        }
      } catch (error) {
        bus.$emit('end:spinner');

        const { data } = error.response;
        this.resultType = data.result;
        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = '이미 사용중인 지면명이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.showSystemAlert = true;
          this.logResult = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        } else {
          console.log(error.response);
        }
      }
    },
    closePopup() {
      const type = this.resultType;
      this.showSystemAlert = false;
      if (type === 'success') {
        this.clearForm();
        this.$emit('refreshList');
      }
    },
    cancel() {
      this.clearForm();
      this.show = false;
      this.$emit('cancelProps');
      bus.$emit('end:spinner');
    },
    clearForm() {
      this.$refs.form.reset();
      this.optionChx = [];
      this.checkedOptionKeys = {};
      this.file = { img: '', name: '', thumb: '' };
    },
    checkAllOrNon() {
      const isAllChecked = this.isAllChecked;
      this.checkedOptionKeys = {};
      this.optionChx = [];
      if (isAllChecked) return;

      this.optionChx = this.media.options.map(o => {
        if (o.key) this.checkedOptionKeys[o.key] = true;
        return o.id;
      });
    },
  },
  created() {
    bus.$emit('start:spinner');
    this.inventory.options.forEach(o => {
      this.optionChx.push(o.id);
      this.checkedOptionKeys[o.key] = true;
      this.propConditions[o.key] = o.condition;
    });
    this.file.thumb = this.inventory.sample_image || '';
    this.useAdvision = this.inventory.use_advision === 'Y';
  },
};
</script>
